import './index.scss';
import AnimatedLetters from '../AnimatedLetters';
import { useState, useEffect } from 'react';
import { faCss3, faHtml5, faJsSquare, faNodeJs, faReact, faGithub } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Loader from 'react-loaders';




const About = () => {

    const [letterClass, setLetterClass] = useState('text-animate');

    useEffect(() => {
        const timer = setTimeout(() => {
            setLetterClass('text-animate-hover')
        }, 3000);
        return () => clearTimeout(timer);
    }, [])


    return (
        <>
        <div className="container about-page">
            <div className="text-zone" style={{ width: '50%' }}>
                <h1>
                    <AnimatedLetters 
                        letterClass={letterClass}
                        strArray={"About me".split("")}
                        idx={15}
                    />
                </h1>
                <p>&nbsp;&nbsp;&nbsp;&nbsp; Hi! I'm Samantha, a passionate and creative Full-Stack Software Engineer with a strong foundation in web development. My journey in this field began with a fascination for crafting digital experiences that have the power to make a positive impact on people's lives. 
                    <br></br> <br></br>
                &nbsp;&nbsp;&nbsp;&nbsp; I have honed my skills in frontend and backend technologies, including HTML, CSS, JavaScript, React, Node.js, and more. I thrive in the world of problem-solving and enjoy the challenge of turning innovative ideas into functional and user-friendly applications.</p>
                <p>&nbsp;&nbsp;&nbsp;&nbsp; I'm a firm believer in lifelong learning, and I actively seek out opportunities to expand my knowledge in the ever-evolving tech landscape. From attending tech meetups to exploring new frameworks and tools, I'm always on the lookout for ways to stay ahead in this dynamic industry. <br></br> <br></br>
                &nbsp;&nbsp;&nbsp;&nbsp; When I'm not immersed in coding, you can find me playing with my dog, trying new foods, or enjoying the outdoors. I thrive in collaborative environments, and I'm eager to collaborate with fellow developers, designers, and creative minds to bring innovative ideas to life.</p>
                <p>&nbsp;&nbsp;&nbsp;&nbsp; Thank you for visiting my portfolio! I hope you enjoy exploring my projects and learning more about my journey in software engineering. If you have any questions or would like to discuss potential collaborations, feel free to reach out. Let's create something amazing together!</p>
            </div>

            <div className='stage-cube-cont'>
                <div className='cubespinner'>
                    <div className='face1'>            
                        <FontAwesomeIcon icon={faReact} color="#5ED4F4" />
                    </div>
                    <div className='face2'>            
                        <FontAwesomeIcon icon={faJsSquare} color="#EFD81D" />
                    </div>
                    <div className='face3'>            
                        <FontAwesomeIcon icon={faNodeJs} color="#28A4D9" />
                    </div>
                    <div className='face4'>            
                        <FontAwesomeIcon icon={faHtml5} color="#F06529" />
                    </div>
                    <div className='face5'>            
                        <FontAwesomeIcon icon={faCss3} color="#28A4D9" />
                    </div>
                    <div className='face6'>            
                        <FontAwesomeIcon icon={faGithub} color="#EC4D28" />
                    </div>
                </div>
                
            </div>
        </div>
        <Loader type="ball-clip-rotate-multiple" />
        </>
    )
}

export default About;